// src/base64.ts
function decode(str, padding = true) {
  try {
    let processedStr = str;
    if (!padding) {
      processedStr = str.replace(/=+$/, "");
    } else if (!/=$/.test(str)) {
      const paddingLength = 4 - str.length % 4;
      if (paddingLength < 4) {
        processedStr = str + "=".repeat(paddingLength);
      }
    }
    if (typeof window !== "undefined") {
      return atob(processedStr);
    }
    return Buffer.from(processedStr, "base64").toString();
  } catch (e) {
    return str;
  }
}
function encode(str, padding = true) {
  try {
    let encoded;
    if (typeof window !== "undefined") {
      encoded = btoa(str);
    } else {
      encoded = Buffer.from(str).toString("base64");
    }
    if (!padding) {
      return encoded.replace(/=+$/, "");
    }
    return encoded;
  } catch (e) {
    return str;
  }
}

export {
  decode,
  encode
};
